// 负责购物车纯函数计算，与 UI 购物车状态和订单创建模块关联。
import type { Product } from "../products";
import type { CartItem, CartLine } from "./types";

export const buildCartLines = (
  items: CartItem[],
  products: Product[]
): CartLine[] => {
  return items.map((item) => {
    const product = products.find((candidate) => candidate.id === item.productId);

    if (!product) {
      throw new Error(`Cart item references unknown product: ${item.productId}`);
    }

    return {
      ...item,
      product,
      lineTotal: product.price * item.quantity
    };
  });
};

export const calculateSubtotal = (lines: CartLine[]): number => {
  return lines.reduce((total, line) => total + line.lineTotal, 0);
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0
  }).format(amount);
};
